const revenueChart = {
    series: [{
        name: 'Visits',
        data: [3, 0, 0, 0, 0, 0, 5, 0, 0, 0, 1, 0]
    }],
    chartOptions: {
        chart: {
            toolbar: {
                show: true,
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '14%',
                endingShape: 'rounded'
            },
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        xaxis: {
            categories: ['Dec 20', 'Jan 21', 'Feb 21', 'Mar 21', 'Apr 21', 'May 21', 'Jun 21', 'Jul 21', 'Aug 21', 'Sep 21', 'Oct 21', 'Nov 21'],
        },
        yaxis: {
            title: {
                text: '(visits count)'
            }
        },
        fill: {
            opacity: 1

        },
        colors: ['#556ee6'],
    }
};

export { revenueChart };